import { Button } from '@prishapolicy/shared/ui';
import React, { useState } from 'react';
import { RemixiconReactIconComponentType } from 'remixicon-react';

export interface CoverageExclusionsProps {
  title: string;
  description: string;
  firstTabValue: string;
  firstTabData: {
    icon: RemixiconReactIconComponentType;
    heading: string;
    description: string;
  }[];
  secondTabValue: string;
  secondTabData: {
    icon: RemixiconReactIconComponentType;
    heading: string;
    description: string;
  }[];
}

export type TabsSelection = 'firstTabSelected' | 'secondTabSelected';
export const CoverageExclusions = (props: CoverageExclusionsProps) => {
  const [isTabSelected, setIsSelectedTab] = useState<TabsSelection>('firstTabSelected');
  return (
    <div className="bg-surface-grey py-12">
      <div className="container flex flex-col items-center justify-center  gap-6">
        <div className="flex flex-col gap-4">
          <h1 className="text-title-3 text-center font-bold">{props.title}</h1>
          <p className="text-grey-700 font-medium">{props.description}</p>
        </div>
        <div className="border-grey-200 flex rounded-lg border-[2px] p-[3px]">
          <Button
            text={props.firstTabValue}
            variant={isTabSelected === 'firstTabSelected' ? 'primary' : 'secondary'}
            className={`w-[118px] border-none font-medium ${isTabSelected !== 'firstTabSelected' && 'text-grey-700'}`}
            size="large"
            onClick={() => setIsSelectedTab('firstTabSelected')}
          />
          <Button
            text={props.secondTabValue}
            variant={isTabSelected === 'secondTabSelected' ? 'primary' : 'secondary'}
            className={`w-[118px] border-none font-medium ${isTabSelected !== 'secondTabSelected' && 'text-grey-700'}`}
            size="large"
            onClick={() => setIsSelectedTab('secondTabSelected')}
          />
        </div>
        {isTabSelected === 'firstTabSelected' ? (
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {props.firstTabData.map((e,idx) => (
              <div key={idx}>
              <CoverageCard icon={e.icon} heading={e.heading} description={e.description} />
              </div>
            ))}
          </div>
        ) : (
          <div className="flex w-full items-center justify-center">
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 items-center">
              {props.secondTabData.map((e,idx) => {
                return (
                  <div className={``} key={idx}>
                    <CoverageCard icon={e.icon} heading={e.heading} description={e.description} />
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export interface CoverageCardProps {
  icon: RemixiconReactIconComponentType;
  heading: string;
  description: string;
}

export const CoverageCard = ({ icon, heading, description }: CoverageCardProps) => {
  const Icon = icon;
  return (
    <div className="flex w-full flex-col items-center  justify-center gap-3">
      <div className="bg-surface-blue text-primary rounded-full p-[9px]">
        <Icon />
      </div>
      <div className="flex flex-col gap-3">
        <h1 className="text-title-5 text-center font-bold">{heading}</h1>
        <p className="text-body-1 w-full text-center font-normal">{description}</p>
      </div>
    </div>
  );
};
